// extracted by mini-css-extract-plugin
module.exports = {"container":"SocialSecurityDetails_container__CpRM_","title":"SocialSecurityDetails_title__1kXFL","content":"SocialSecurityDetails_content__5MCYU"};